<template>
  <v-dialog
    v-model="isDialog"
    max-width="600"
    persistent
    content-class="customize-dialog"
  >
    <v-card class="pa-4">
      <v-card-title class="text-h6 font-weight-600 pl-4">
        <span class="secondary--font text-capitalize">
          Delete Custom View
        </span>
      </v-card-title>

      <v-card-text class="body-2 px-4 mt-5">
        <p>Are you sure you want to delete the selected custom view?</p>
        <p><strong>Warning: You cannot undo this action.</strong> </p>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          @click="closeDialog()"
          class="font-weight-bold"
          v-track="'cancel-delete-action'"
        >
          Cancel
        </v-btn>
        <v-btn
          @click="deleteView()"
          class="font-weight-bold"
          v-track="'delete-custom-view'"
          dark
        >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import { $filter } from "@/services/Index";
  export default {
    name: 'delete-view-dialog',
    props: ["deleteViewDialog"],
    data() {
      return {
        isDialog: false,
        deleteId: null,
      }
    },
    methods: {
      /**
       * Function to open delete view dialog.
       * @param {*} id 
       */
      openDialog(id = null){
        this.isDialog = true;
        this.deleteId = id;
      },
      /**
       * Function to close delete view dialog.
       */
      closeDialog(){
        this.deleteId = null
        this.isDialog = false;
      },
      /**
       * Function to delete saved view here.
       */
      async deleteView(){
        try {
          const response = await $filter.deleteFilter(this.deleteId);
          if(response){
            this.$store.dispatch("ui/snackbar", [
              {
                title: "Custom View",
                message: `Custom View has been deleted successfully.`,
                type: "success",
              },
            ]);
            this.$emit("evtOnCloseDeleteViewDialog");
            this.closeDialog();
          }
        } catch (error) {}
      },
    }
  }
</script>